import { render, staticRenderFns } from "./FullScreenItem.vue?vue&type=template&id=61c77b06&scoped=true"
import script from "./FullScreenItem.vue?vue&type=script&lang=js"
export * from "./FullScreenItem.vue?vue&type=script&lang=js"
import style0 from "./FullScreenItem.vue?vue&type=style&index=0&id=61c77b06&prod&scoped=true&lang=css"
import style1 from "./FullScreenItem.vue?vue&type=style&index=1&id=61c77b06&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c77b06",
  null
  
)

export default component.exports